import React from 'react';
import { useNavigate } from 'react-router-dom';
import { mockBlogPosts } from '../pages/blog';
import { Link } from 'react-router-dom';

const Blog = () => {
  const navigate = useNavigate();

  const handleBlogClick = (slug) => {
    if (slug && slug !== '#') {
      navigate(`/blog/${slug}`);
    }
  };

  return (
    <section className="blog">
      <div className="section-header">
        <h2>Latest from the MemU blog</h2>
        <p>Stay updated with the latest news and stories.</p>
      </div>
      <div className="blog-container">
        {mockBlogPosts.slice(0, 3).map((post, index) => (
          <div
            key={index}
            className="blog-card"
            onClick={() => handleBlogClick(post.slug)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleBlogClick(post.slug);
              }
            }}
            tabIndex={0}
            role="button"
            aria-label={`Read blog post: ${post.title}`}
          >
            <div className="blog-image">
              <img src={post.image} alt={`Cover for ${post.title}`} />
            </div>
            <div className="blog-content">
              <span className="date">{post.date}</span>
              <h3>{post.title}</h3>
            </div>
          </div>
        ))}
      </div>
      {
        mockBlogPosts.length > 3 && (
          <div className="blog-more">
            <Link to="/blog">
              View All
            </Link>
          </div>
        )
      }
    </section>
  );
};

export default Blog;